import React from "react";
import {
  List,
  Edit,
  SimpleForm,
  Datagrid,
  DateField,
  TextField,
  EmailField,
  ReferenceField,
  SelectInput,
  EditButton,
  DeleteButton
} from "react-admin";
import { DoctorReferenceField } from "../../misc/customFields";
import { OkCancelToolbar } from "../../misc/customComponents";

export const UnverifiedUserList = props => {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="id" />
        <EmailField source="email" />
        <DoctorReferenceField allowEmpty/>
        <TextField source="status" />
        <DateField source="created" />
        <DateField source="updated" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};

export const UnverifiedUserEdit = props => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<OkCancelToolbar />}>
        <EmailField source="email" />
        <DoctorReferenceField source="user" allowEmpty/>
        <SelectInput
          source="status"
          choices={[
            { id: "verified", name: "verified" },
            { id: "unverified", name: "unverified" }
          ]}
        />
      </SimpleForm>
    </Edit>
  );
};
